import { TRIGGER_GET_ALL_COVER_OPTIONS, COLLECT_SHARE_QUOTE_FORM_DATA } from '../../../actions/personalAccident/quote';
import { getCoverOptionsService } from './coverOptions';
import { shareQuoteService } from './shareQuote';

import {
    TRIGGER_PAYMENTS_STK_PUSH,
    TRIGGER_CONFIRM_ORDER,
    CHECK_PAYMENTS_STATUS,
    SUBMIT_PAYMENT_DETAILS_DATA,
    SUBMIT_FAILED_PAYMENT_DETAILS_DATA,
} from '../../../actions/personalAccident/payments';
import { paymentsStkService, paymentsStkStatusService } from './payments';
import { orderConfirmationService } from './orderConfirmation';
import { paymentDetailsSubmitService, paymentFailedDetailsSubmitService } from './submitPaymentDetails';

import { COLLECT_PAYLOAD_DATA } from '../../../actions/personalAccident/payloadCollection';
import { payloadSubmitService } from './payloadCollection';

import { COLLECT_LOGIN_DETAILS } from '../../../actions/personalAccident/auth';
import { loginService } from './login';

import { TRIGGER_AGENT_TYPE } from '../../../actions/personalAccident/agentModal';
import { getIntermediaryAgent } from './agent';

import { COLLECT_LIVES_COVERED_DATA } from '../../../actions/personalAccident/personalDetails';
import { livesCoveredSubmitService } from './submitLivesCovered';

import { SUBMIT_DOCUMENTS_DATA } from '../../../actions/personalAccident/Documents';
import { documentsSubmitService } from './submitDocuments';

import { SUBMIT_DECLARATIONS_DATA } from '../../../actions/personalAccident/declarations';
import { declarationsSubmitService } from './submitDeclarations';

import { SUBMIT_NEXT_OF_KIN_DATA } from '../../../actions/personalAccident/nextOfKin';
import { nextOfKinSubmitService } from './submitNextOfKin';

import {
    INITIATE_PAYMENT,
    PAYSTACK_CHECK_PAYMENTS_STATUS,
    PAYSTACK_SUBMIT_PAYMENT,
} from '../../../actions/personalAccident/paystack';
import { paystackStkStatusService, paystackPaymentService, submitPaymentService } from './paystack';

export const personalAccidentCover = (store, next, action) => {
    if (action.type.startsWith(INITIATE_PAYMENT)) {
        return paystackPaymentService(store, next, action);
    }
    if (action.type.startsWith(PAYSTACK_CHECK_PAYMENTS_STATUS)) {
        return paystackStkStatusService(store, next, action);
    }
    if (action.type.startsWith(PAYSTACK_SUBMIT_PAYMENT)) {
        return submitPaymentService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }
    if (action.type.startsWith(CHECK_PAYMENTS_STATUS)) {
        return paymentsStkStatusService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_PAYLOAD_DATA)) {
        return payloadSubmitService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA)) {
        return shareQuoteService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_ALL_COVER_OPTIONS)) {
        return getCoverOptionsService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_CONFIRM_ORDER)) {
        return orderConfirmationService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_AGENT_TYPE)) {
        return getIntermediaryAgent(store, next, action);
    }

    if (action.type.startsWith(COLLECT_LIVES_COVERED_DATA)) {
        return livesCoveredSubmitService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_NEXT_OF_KIN_DATA)) {
        return nextOfKinSubmitService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_DOCUMENTS_DATA)) {
        return documentsSubmitService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_DECLARATIONS_DATA)) {
        return declarationsSubmitService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_PAYMENT_DETAILS_DATA)) {
        return paymentDetailsSubmitService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_FAILED_PAYMENT_DETAILS_DATA)) {
        return paymentFailedDetailsSubmitService(store, next, action);
    }

    return null;
};
